module.exports = __webpack_public_path__ + "static/media/transilluminator-closed-with-gel.99b0c207.svg";